import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { DesignModel } from '@app/shared/models/design';
import { AppConstant } from '@app/shared/constants';
import { FilterModel, FilterModelStoreFront, UpdateStoreProductStatusRequest } from '@app/shared/models/product';
import { DeleteCustomizedProduct } from '@app/feature/end-user/models/cart';

@Injectable({
  providedIn: 'root'
})
export class InksoftService {
  constructor(private http: HttpClient) { }

  baseUrl = environment.baseUrl;
  publisherId = 11016;
  storeUri = 'Stoked_On_Printing_Online';

  /** Function to save newly customized product to database */
  saveCustomizedDesign(designModel: DesignModel) {
    return this.http.post(this.baseUrl + AppConstant.SAVE_CUSTOMIZED_PRODUCT, designModel);
  }
  /** Function to save newly customized product to database */
  updateCustomizedDesign(designModel: DesignModel) {
    return this.http.post(this.baseUrl + AppConstant.UPDATE_CUSTOMIZED_PRODUCT, designModel);
  }

  /** Function to GET list of/for customized product(s) screen*/
  getCustomizedProductsList(filterModel: FilterModel) {
    return this.http.post<any>(this.baseUrl + AppConstant.GET_CUSTOMIZED_PRODUCTS, filterModel);
  }

  /**
   * WI-1579: set one store's product(s) Active/Draft in that store's Shopify (single or bulk).
   * Returns a per-item result so a bulk call can partly succeed.
   */
  updateStoreProductStatus(request: UpdateStoreProductStatusRequest) {
    return this.http.post<any>(this.baseUrl + AppConstant.UPDATE_STORE_PRODUCT_STATUS, request);
  }
/**Gets customize product listing with params: searchString, skipNoOfRecord, takeNoRecord, IsPaginationFilteringRequired.
   * IsPaginationFilteringRequired = false, means pagination, searching, filterinig is not required */
  getCustomizedProductsListWithSearch(searchString: any, skipNoOfRecord: number, takeNoRecord: number,
     IsPaginationFilteringRequired: boolean,
    ApplicationUserId: number) {
    return this.http.get<any>(this.baseUrl + AppConstant.GET_CUSTOMIZED_PRODUCTS + '?searchBy=' + searchString +
    '&skipRecords=' + skipNoOfRecord + '&takeRecords=' + takeNoRecord + '&IsPaginationFilteringRequired=' + IsPaginationFilteringRequired +
    '&ApplicationUserId=' + ApplicationUserId);
  }
  /** Function to GET list of customized product(s) for store front*/
  getStorePublishProductList(filterModel: FilterModelStoreFront) {
    return this.http.post<any>(this.baseUrl + AppConstant.GET_STOREFRONT_PRODUCTS, filterModel);
  }

  getProduct(categoryId: string) {
   return this.http.get(this.baseUrl + this.storeUri + '/Api2/GetProductsByCategory?CategoryId=' + categoryId + '&Format=JSON');
    }

  getBrands() {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.baseUrl + this.storeUri + '/Api2/GetManufacturers?BlankProducts=false&Format=JSON&ProductType=standard&StaticProducts=false');
  }

  /** delete customized product */
  deleteCustomizedProduct(model: DeleteCustomizedProduct) {
    return this.http.post<any>(environment.baseUrl + AppConstant.DeleteCustomizedProduct, model);
  }

  loginInksoft(storeId: any){
    return this.http.get(this.baseUrl + AppConstant.LOGIN_INKSOFT + '?storeId=' + storeId);
  }

}
